// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { BenefitDeliveryOperationsService } from '../generated/api/benefitDeliveryOperations.service';

@Injectable({ providedIn: 'root' })
export class BenefitDeliveryOperationsClientService {
  constructor(private readonly client: BenefitDeliveryOperationsService) {}
  // <generated-client-wrappers:methods>
  get(
    page?: number,
    pageSize?: number,
    consumerAppId?: string,
    transactionId?: string,
    allocationId?: string,
    state?: 1 | 2 | 3 | 4,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.BenefitDeliveryPage> {
    if (!this.client)
      throw new Error('BenefitDeliveryOperationsService is not available');
    return this.client.benefitDeliveryOperationsGet(
      page,
      pageSize,
      consumerAppId,
      transactionId,
      allocationId,
      state,
      'body',
      reportProgress,
      options,
    );
  }

  getRestorations(
    allocationId: string,
    page?: number,
    pageSize?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.BenefitRestorationPage> {
    if (!this.client)
      throw new Error('BenefitDeliveryOperationsService is not available');
    return this.client.benefitDeliveryOperationsGetRestorations(
      allocationId,
      page,
      pageSize,
      'body',
      reportProgress,
      options,
    );
  }

  getRetries(
    allocationId: string,
    revision: number,
    page?: number,
    pageSize?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.BenefitDeliveryRetryPage> {
    if (!this.client)
      throw new Error('BenefitDeliveryOperationsService is not available');
    return this.client.benefitDeliveryOperationsGetRetries(
      allocationId,
      revision,
      page,
      pageSize,
      'body',
      reportProgress,
      options,
    );
  }

  restore(
    allocationId: string,
    request: WrapperApi.BenefitRestorationRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.BenefitRestorationResponse> {
    if (!this.client)
      throw new Error('BenefitDeliveryOperationsService is not available');
    return this.client.benefitDeliveryOperationsRestore(
      allocationId,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  retry(
    allocationId: string,
    revision: number,
    request: WrapperApi.BenefitDeliveryRetryRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.BenefitDeliveryRetryResponse> {
    if (!this.client)
      throw new Error('BenefitDeliveryOperationsService is not available');
    return this.client.benefitDeliveryOperationsRetry(
      allocationId,
      revision,
      request,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
